module.exports = __webpack_public_path__ + "img/01.cc986f78.png";